module.exports = __webpack_public_path__ + "img/acu_logo.c5f2a0c5.png";